
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 62 62"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(2 2)","fill":"none","fill-rule":"evenodd","opacity":".75"}},[_c('circle',{attrs:{"stroke":"var(--vote-color, #fff)","stroke-width":"3","cx":"29","cy":"29","r":"29"}}),_c('path',{attrs:{"d":"M18.208 37.395c7.054 7.164 13.984 7.164 21.632-.047a1.812 1.812 0 112.487 2.637c-9.062 8.544-18.243 8.544-26.702-.047a1.813 1.813 0 012.583-2.543zm-2.087-13.626c.93-1.86 1.693-2.623 2.004-2.623.31 0 1.074.763 2.004 2.623a1.812 1.812 0 003.242-1.621c-1.487-2.974-3.14-4.627-5.246-4.627-2.106 0-3.76 1.653-5.246 4.627a1.812 1.812 0 103.242 1.62zm21.75 0c.93-1.86 1.693-2.623 2.004-2.623.31 0 1.074.763 2.004 2.623a1.812 1.812 0 003.242-1.621c-1.487-2.974-3.14-4.627-5.246-4.627-2.106 0-3.76 1.653-5.246 4.627a1.812 1.812 0 103.242 1.62z","fill":"var(--vote-color, #fff)","fill-rule":"nonzero"}})])])
          )
        }
      }
    